<template>
  <div class="nav">
    <div class="flex">
      <div @click.stop="goHome"><van-image :src="require('../assets/logo.png')" width="152px" height="46px" style="cursor: pointer;" /></div>
      <div v-if="title" class="ml10 pt15" style="padding-top: 0;"><van-image :src="require('../assets/logo-title.png')" width="120px" height="46px" /></div>
      <div v-if="search" class="f14 c222 ml42 search-fix">
        <van-field v-model="searchText" center placeholder="商品名称/功效" @input="input" @click="input">
          <template #button>
            <van-button size="small" type="primary" @click.stop="goSearch(searchText)">
              <van-icon :name="require('../assets/search-icon.png')" size="26px" style="margin-top: -3px;" />
            </van-button>
          </template>
        </van-field>
        <!-- 模糊搜索回显 -->
        <div
          v-if="showSearchPanel"
          class="search-keyword-panel"
          @mouseleave="
            () => {
              showSearchPanel = false;
            }
          "
        >
          <ul>
            <li v-for="(word, i) in searchKeyWords" :key="i">
              <!-- <span @click.stop="goSearch(word.KeyWord)" class="c999 ihover">{{ _truncature(word.KeyWord, 20) }}</span> -->
              <span class="c999 ihover" @click.stop="goSearch(word.KeyWord)" v-html="word.replaceString" />
            </li>
          </ul>
        </div>
        <!-- 模糊搜索回显 end -->

        <div v-if="searchRecord" class="search-text text-left ellipsis-row1">
          <ul>
            <li class="c0F6EEA">您常搜</li>
            <li v-for="(item, index) in dataKeyWords" :key="index">
              <span class="c999 ihover" @click.stop="goSearch(item)">{{ _truncature(item, 5) }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="carBtn" class="carBtn flex align-items-center justify-content-center">
        <router-link :to="LinkTypeCode.BuyCar">
          <van-icon :name="require('../assets/car-icon.png')" :badge="carCount > 99 ? '99+' : carCount" size="20px" />
          <span>我的购物车</span>
        </router-link>
      </div>
      <!-- <div v-if="carBtn" class="ml20 pt15" style="padding-top: 0;"><van-image :src="require('../assets/price.png')" width="116px" height="40px" @click.stop="price" /></div> -->
      <!-- <div class="flex tel-box align-items-center" v-if="phone">
              <van-icon :name="require('../assets/tel-icon.png')" size="31px" />
              <span class="fAkrobat c0F6EE9 fw900 f24 ml10">400-9807-0987</span>
            </div>-->
      <div v-if="content" class="f20 fw600 c222 pb3 flex align-items-end ml37 w100"><slot name="content" /></div>
    </div>
  </div>
</template>
<script>
import { BaseMixin } from '../mixins/BaseMixin'
import { LinkTypeCode } from '../dictionary/base.js'
import merge from 'webpack-merge'

export default {
  name: 'Nav',
  mixins: [BaseMixin],
  props: {
    search: {
      type: Boolean,
      default: true
    },
    searchRecord: {
      type: Boolean,
      default: true
    },
    carBtn: {
      type: Boolean,
      default: true
    },
    phone: {
      type: Boolean,
      default: true
    },
    content: {
      type: Boolean,
      default: false
    },
    title: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      LinkTypeCode,
      carCount: 0,
      searchText: '',
      showSearchPanel: false,
      searchKeyWords: [],
      dataKeyWords: []
    }
  },
  mounted() {
    if (this.carBtn) {
      this.refCartCount()
    }
    if (this.search) {
      this.getSearchRecord()
    }
    this.registerBusEvent()
  },
  methods: {
    price() {
      this.$router.push({
        path: LinkTypeCode.DisorderlyPrice

      })
    },
    clearSearchText() {
      this.searchText = ''
    },
    registerBusEvent() {
      this.$bus.$on('buycarChanged', (count, isCar) => {
        this.carCount = count
      })
    },
    // 获取搜索记录
    async getSearchRecord() {
      const res = await this.getAction('api_customers/CustomerSearchRecord/GetCustomerSearchInfo')
      if (res.IsSuccess) {
        this.dataKeyWords = res.Data.KeyWords
      }
    },
    refCartCount() {
      this.$hys.openLoading()
      this.getAction('/api_order/ShoppingCarts/Count').then(res => {
        this.$hys.clearLoading()
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.carCount = res.Data.ProductCount
      })
    },
    async input() {
      const res = await this.getAction('/api_customers/CustomerSearchRecord/GetTotalSearchInfo?keyWord=' + this.searchText)
      if (res.IsSuccess) {
        if (res.Data && res.Data.length > 0) {
          // 根据关键字过滤出相关数据
          this.searchKeyWords = res.Data.filter(item => {
            return Object.keys(item).some(key => {
              return String(item[key]).indexOf(this.searchText) > -1
            })
          })

          // 替换关键字
          this.searchKeyWords = this.searchKeyWords.map(item => {
            for (const key in item) {
              if (key === 'KeyWord') {
                // 匹配关键字正则
                const replaceReg = new RegExp(this.searchText, 'g')
                // 拼接v-html高亮字符，默认样式只设置了字体颜色红色
                const replaceString = '<span class="highlights-text">' + this.searchText + '</span>'
                // 替换
                // item[key] = item[key].replace(replaceReg, replaceString);
                item.replaceString = item[key].replace(replaceReg, replaceString)
              }
            }
            return item
          })

          this.showSearchPanel = true
        } else {
          if (this.dataKeyWords.length > 0) {
            this.showSearchPanel = true
            this.searchKeyWords = []
            this.dataKeyWords.forEach(word => {
              this.searchKeyWords.push({ KeyWord: word })
            })
          }
        }
      }
    },
    goHome() {
      this.$router.push('/')
    },
    goSearch(searchText) {
      console.log(searchText)
      this.showSearchPanel = false
      if (this.$router.history.current.name == LinkTypeCode.SearchPage) {
        this.$router.push({
          query: merge({}, {})
        })
        this.$router.push({
          query: merge({}, { keyword: searchText })
        })
        this.$bus.$emit('reload', searchText)
      } else {
        this.$router.push({
          name: LinkTypeCode.SearchPage,
          query: { keyword: searchText }
        })
      }
      this.searchText = searchText
    }
  }
}
</script>
<style lang="less" scoped>
.highlights-text {
  color: #FF5134;
}

.nav {
  // padding-bottom: 24px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 8px 12px 0 rgba(238, 238, 238, .5);

  > div {
    margin: 0 auto;
    padding-top: 24px;
    width: 1200px;

    .mr52 {
      margin-right: 52px;
    }

    .van-cell {
      margin-right: 54px;
      border: 2px solid rgba(15, 110, 233, 1);
      border-radius: 2px;
      padding: 0;
      padding-left: 20px;
      width: 548px;
      height: 40px;

      &::after {
        border: 0;
      }

      .van-button {
        border: 0;
        width: 100px;
        height: 40px;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
        background: rgba(15, 110, 233, 1);
      }
    }

    .search-keyword-panel {
      position: absolute;
      z-index: 999;
      margin: 1px 0 0 1px;
      padding: 10px;
      min-width: 300px;
      height: auto;
      font-size: 16px;
      text-align: left;
      background: white;
      box-shadow: 0 0 0 1px #E8E8E8;

      ul li {
        margin: 20px 10px;

        > span {
          cursor: pointer;
        }
      }
    }

    .search-text {
      margin-top: 10px;
      padding-right: 50px;
      // width: 550px;
      height: 25px;

      ul li {
        display: inline-block;
        margin-right: 10px;

        > span {
          border-right: 1px solid #E5E5E5;
          padding-right: 10px;
          cursor: pointer;
        }

        &:last-child {
          margin-right: 0;

          > span {
            border-right: 0;
            padding-right: 0;
          }
        }
      }
    }

    .carBtn {
      border: 1px solid rgba(15, 110, 233, 1);
      border-radius: 2px;
      padding: 0;
      width: 128px;
      height: 38px;
      font-size: 14px;
      color: rgba(15, 110, 234, 1);

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 128px;
        height: 100%;
        color: rgba(15, 110, 234, 1);
      }

      span {
        margin-left: 18px;
      }

      &:hover {
        background: #EBF4FF;
      }
    }

    .tel-box {
      margin-top: 4px;
      height: 32px;
    }
  }
}

.pb3 {
  padding-bottom: 3px;
}

.ml37 {
  margin-left: 37px;
}

.ml42 {
  margin-left: 42px;
}

.ml20 {
  margin-left: 20px;
}

.w100 {
  width: 100%;
}

.search-fix {
  position: relative;

  /deep/ .van-cell {
    position: unset;
  }

  /deep/.van-cell__value {
    position: unset;
  }

  /deep/.van-field__button {
    position: absolute;
    top: 0;
    right: 54px;
  }
}
</style>
